export const SUB_SECTIONS = {
  OVERVIEW: 1,
  ANALYTICS: 2,
  DRILLING_ACTIVITIES: 3,
  EQUIPMENT: 4,
  POWER_MGMT: 5
};

export const BASELINE_SUB_SECTIONS = {
  PERIODIC_OVERVIEW: 'Periodic overview',
  DRILLING_ACTIVITIES: 'Drilling activities',
  EQUIPMENT: 'Equipment',
  POWER_MGMT: 'Power mgmt SFOC',
  ANALYTICS: 'Analytics'
};

export const VALID_TARGET_BASELINE_SECTIONS = [
  BASELINE_SUB_SECTIONS.PERIODIC_OVERVIEW,
  BASELINE_SUB_SECTIONS.ANALYTICS
];

export const API_ROLLUP = {
  DAY: 'PT24H',
  HOUR: 'PT1H',
  QUARTER: 'PT15M',
  MIN: 'PT1M'
};
export const DISPLAY_UNIT = {
  CO2: 'CO2',
  NOX: 'NOx',
  FUEL: 'Fuel',
  ENERGY: 'Energy'
};

export const WARNINGS = {
  TooManyEng: 'Too many engines running',
  MP_AUX_Idle: 'Idle mud pumps',
  TooManyHPU: 'Too many HPU pumps online',
  DW_AUX_Idle: 'Idle drawworks',
  TooManyAgitators: 'Idle agitators'
};
export const WARNINGS_TYPE = {
  TooManyEng: 'TooManyEng',
  MP_AUX_Idle: 'MP_AUX_Idle',
  TooManyHPU: 'TooManyHPU',
  DW_AUX_Idle: 'DW_AUX_Idle',
  TooManyAgitators: 'TooManyAgitators'
} as const;

export const WARNINGS_EQUIPMENT_REQUIREMENT = [
  {
    warning: WARNINGS_TYPE.DW_AUX_Idle,
    equipment: 'Drawworks'
  },
  {
    warning: WARNINGS_TYPE.MP_AUX_Idle,
    equipment: 'Mud Pumps'
  },
  {
    warning: WARNINGS_TYPE.TooManyAgitators,
    equipment: 'Agitators'
  },
  {
    warning: WARNINGS_TYPE.TooManyEng,
    equipment: 'All'
  },
  {
    warning: WARNINGS_TYPE.TooManyHPU,
    equipment: 'Ringline HPU'
  }
];

export const UNIT_LIMIT = {
  CO2: 0.1,
  NOX: null,
  FUEL: 0.1,
  ENERGY: 10000
};

export const BASELINE_TYPE = {
  TIME_WELL: 1,
  TARGET: 2
};

export const DISPLAY_PERIOD = {
  LAST_DAY: 1,
  LAST_WEEK: 2,
  LAST_MONTH: 3,
  LAST_YEAR: 4,
  ALL_TIME: 5
};
export const OPERATION_TYPE = {
  ALL: 1,
  DRILLING: 2,
  HOTEL_AND_UTILITIES: 3
};

export const SFOC_OR_LOAD = {
  SFOC: 1,
  LOAD: 2
};

export const VIEW_BY_TYPE = {
  DAILY: 1,
  HOURLY: 2
};

export const DATA_TYPE = {
  ACCUMULATED: 1,
  DISCRETE: 2
};

export const BASELINE_CHART_TYPE = {
  BY_TIME: 1,
  BY_ACTIVITIES: 2
};

export const TIME_ZONE = {
  RIGS_LOCATION: 'RigsLocation',
  CUSTOM_TIME_ZONE: 'CustomTimeZone'
};
